import {
  ACCOUNT_INITIALISE,
  LOGIN,
  LOGOUT,
  OTP_VALIDATION_SUCCESS,
  OTP_VALIDATION_FAIL,
} from "../constants/constants";
const accountReducer = (state, action) => {
  switch (action.type) {
    case ACCOUNT_INITIALISE: {
      const { isLoggedIn, isOTPValidated, user, users } = action.payload;
      return {
        ...state,
        isLoggedIn,
        isOTPValidated,
        isInitialised: true,
        user,
        users,
      };
    }
    case LOGIN: {
      const { phoneNumber } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isOTPValidated: false,
        phoneNumber,
      };
    }
    case OTP_VALIDATION_SUCCESS: {
      const { user } = action.payload;
      return {
        ...state,
        isOTPValidated: true,
        user: user,
      };
    }
    case OTP_VALIDATION_FAIL: {
      return {
        ...state,
        isOTPValidated: false,
        user: null,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isLoggedIn: false,
        isOTPValidated: false,
        user: null,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
